import gql from 'graphql-tag'

export const PersonPartsFragment = gql`
  fragment PersonParts on Person {
    id
    anonymized_at
    first_name
    last_name
    date_of_birth
    city
    post_code
    street
    street_no
    street_no_flat
    phone
    internal_phone
    mobile_phone
    group_ids
    uuid
    active
    user {
      id
      email
      locked
    }
    company_ids
    photo {
      id
      url
      thumb_url
    } 
  }
`

export const PeopleListFetchQuery = gql`
  query PeopleListQuery($pageSize: Int = 10, $page: Int = 1, $filters: PeopleFilterInput) {
    people(page: $page, size: $pageSize, filters: $filters) {
      list {
        ...PersonParts
      }
      metadata {
        total_count
        total_pages
        prev_page
        current_page
        next_page
      }
    }
    groups {
      id
      name
    }
    companies {
      list {
        id
        name
      }
    }
  }
${PersonPartsFragment}
`


export const createOrUpdatePersonsMutation = gql`
  mutation createOrUpdatePersons (
    $id: ID,
    $uuid: String,
    $active: Boolean,
    $first_name: String,
    $last_name: String,
    $date_of_birth: String,
    $city: String,
    $post_code: String,
    $street: String,
    $street_no: String,
    $street_no_flat: String,
    $phone: String,
    $internal_phone: String,
    $mobile_phone: String,
    $group_ids: [ID],
    $company_ids: [ID]
  ) {
    createOrUpdatePersons (
      id: $id,
      uuid: $uuid,
      active: $active,
      first_name: $first_name,
      last_name: $last_name,
      date_of_birth: $date_of_birth,
      city: $city,
      post_code: $post_code,
      street: $street,
      street_no: $street_no,
      street_no_flat: $street_no_flat,
      phone: $phone,
      internal_phone: $internal_phone,
      mobile_phone: $mobile_phone,
      group_ids: $group_ids,
      company_ids: $company_ids
    ) {
      person {
        ...PersonParts
      }
      errors
    }
  }
${PersonPartsFragment}
`

export const GroupsFetchQuery = gql`
  query GroupsFetchQuery {
    groups {
      id
      name
      permissions
    }
  }
`
export const createOrUpdateGroupsMutation = gql`
  mutation createOrUpdateGroups ($id: ID, $name: String, $permissions: String) {
    createOrUpdateGroups (
      id: $id,
      name: $name,
      permissions: $permissions,
    ) {
      group {
        id
        name
        permissions
      }
      errors
    }
  }
`

export const GroupPeopleQuery = gql`
  query GroupPeopleQuery($group_id: ID!) {
    groupPeople(group_id: $group_id) {
      id
      first_name
      last_name
      uuid
    }
  }
`

export const SearchPeopleQuery = gql`
  query SearchPeopleQuery($filters: PeopleFilterInput, $size: Int) {
    people(filters: $filters, size: $size) {
      list {
        id
        first_name
        last_name
        uuid
      }
    }
  }
`

export const removePersonFromGroupMutation = gql`
  mutation removePersonFromGroup ($group_id: ID!, $person_id: ID!) {
    removePersonFromGroup (group_id: $group_id, person_id: $person_id) {
      id
      group_ids
    }
  }
`

export const addPersonToGroupMutation = gql`
  mutation addPersonToGroup ($group_id: ID!, $person_id: ID!) {
    addPersonToGroup (group_id: $group_id, person_id: $person_id) {
      id
      group_ids
    }
  }
`

export const createOrUpdateUsersMutation = gql`
  mutation createOrUpdateUser (
    $id: ID,
    $email: String!,
    $password: String,
    $password_confirmation: String,
    $person_id: Int,
  ) {
    createOrUpdateUser (
      id: $id,
      email: $email,
      password: $password,
      password_confirmation: $password_confirmation,
      person_id: $person_id
    ) {
      person {
        id
        user {
          id
          email
          locked
        }
      }
      errors
    }
  }
`

export const changeUserAccessMutation = gql`
  mutation changeUserAccess($user_id: Int!) {
    changeUserAccess(user_id: $user_id) {
      id
      locked
    }
  }
`
export const anonymizePersonMutation = gql`
  mutation anonymizePerson($person_id: ID!) {
    anonymizePerson(person_id: $person_id) {
      ...PersonParts
    }
  }
${PersonPartsFragment}
`

export const GET_PERSON = gql`
  query getPerson($id: ID!) {
    person(id: $id) {
      ...PersonParts
    }
    groups {
      id
      name
    }
    companies {
      list {
        id
        name
      }
    }
  }
${PersonPartsFragment}
`



// WEBPACK FOOTER //
// ./src/components/People/mutations.js